import { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useIntl } from "react-intl";
import { faSort, faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function sortLibraryItems(items, columns, sort, locale) {
  const column = columns.find((item) => item.key === sort.key);
  if (!column) return items;
  const compare = new Intl.Collator(locale, { numeric: true, sensitivity: "base" });
  return [...items].sort((left, right) => {
    const a = column.value(left);
    const b = column.value(right);
    const result = typeof a === "number" && typeof b === "number" ? a - b : compare.compare(a ?? "", b ?? "");
    return sort.ascending ? result : -result;
  });
}

export default function LibraryTable({ items, columns, renderRow }) {
  const intl = useIntl();
  const [sort, setSort] = useState({ key: null, ascending: true });
  return (
    <Table striped borderless responsive className="mt-3">
      <thead>
        <tr className="border-bottom">
          <th style={{ width: "2rem" }} />
          {columns.map((column) => (
            <th
              key={column.key}
              style={column.compact ? { width: "1%" } : undefined}
              aria-sort={sort.key === column.key ? (sort.ascending ? "ascending" : "descending") : "none"}
            >
              <Button
                variant="link"
                className="p-0 text-start"
                onClick={() =>
                  setSort({ key: column.key, ascending: sort.key === column.key ? !sort.ascending : true })
                }
              >
                {intl.formatMessage({ id: column.label })}
                <FontAwesomeIcon
                  className="ms-2"
                  size="xs"
                  icon={sort.key === column.key ? (sort.ascending ? faSortUp : faSortDown) : faSort}
                />
              </Button>
            </th>
          ))}
          <th style={{ width: "1%" }} />
        </tr>
      </thead>
      <tbody>{sortLibraryItems(items, columns, sort, intl.locale).map(renderRow)}</tbody>
    </Table>
  );
}
